module.exports = __webpack_public_path__ + "static/bgMobile-min-9a276e6fd154ca558eb47df0da5f9607.jpg";